export default {"src":"/_next/static/media/ic_keyboard_arrow_left.2a74ea97.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};